class CarouselSlider {
    constructor(blockMain) {
        this.blockMain = blockMain ?? false;
        this.filterWrap = this.blockMain.querySelector('.js-voyager-carousel__filter') ?? false;
        if(this.filterWrap) {
            this.filters = this.filterWrap.querySelector('ul') ?? false;
            this.selectedItem = this.filterWrap.querySelector('.js-carousel-filter-selected-item');
        }
        this.filterItem = '';
        this.splide;
        this.splideElement;
        this.hasPopup = false;
        this.popupMain;
        this.popupSliderData;
    }

    handleFilterClick() {
        var _self = this,
            filterItems,
            splideList = '';
            
        if(_self.filters && _self.filters.children.length !== 0) {
            for (const item of _self.filters.children) {
                item.addEventListener('click', function() {
                    _self.handleClosePopup();
                    splideList = _self.splide.root.querySelector('.splide__list')
                    _self.removeClassFromFilterItems();
                    var activeItem = _self.addClassToFilterItem(item);
                    _self.selectedItem.querySelector('span').innerText = activeItem;
                    _self.filterItem = this.dataset.filter;
                    filterItems = _self.getFilterSliderItems();

                    splideList.innerHTML = _self.newFilterItemHTML(filterItems);
                    _self.splide.destroy();
                    _self.splide.mount();
                    _self.handleHoverItem();
                })
            }
            
            _self.handleMobileSelectedItem();
        }
    }

    removeClassFromFilterItems() {
        var _self = this;
        for (const item of _self.filters.children) {
            item.classList.remove('is-active'); 
        }

        _self.filterWrap.classList.remove('filter-dropdown-active');
    } 

    addClassToFilterItem(item) {
        item.classList.add('is-active');

        return item.innerText
    }  

    getFilterSliderItems() {
        var _self = this,
            tempData = [],
            i = 0;
        _self.splideElement.forEach(function (item) {
            let filters = item.slide.dataset.filter.split(',');
            if (filters.includes(_self.filterItem)) {
                tempData[i] = item
                i++;
            }
        });
        
        return tempData
    } 

    newFilterItemHTML(arr) {
        var outputHTML = ''
        arr.forEach(item => {
            outputHTML += item.slide.outerHTML;
        });

        return outputHTML
    }
    
    handleHoverItem() {
        var _self = this;

        _self.splide.Components.Elements.slides.forEach((item, i) => {
            item.addEventListener('click', function() {
                if(!_self.hasPopup && _self.blockMain.classList.contains('filter-popup')) {
                    const ele = document.createElement('div');
                    ele.classList.add('voyager-carousel__popup', 'js-carousel-popup');
                    _self.blockMain.querySelector('.voyager-carousel__splide').appendChild(ele);
                    _self.popupMain = document.querySelector('.js-carousel-popup');
                    _self.setPopupSliderData();
                    ele.innerHTML = _self.popupHTML();
                    _self.splideInit(i);
                    _self.handleMouseOut();
                    _self.hasPopup = true
                }
            })
        });            
    }

    popupHTML() {
        var _self = this;
        var outputHTML = `
                        <div class="voyager-carousel__popup-container">
                            <div class="voyager-carousel__popup-close js-carousel-popup-close">+</div>
                            <div class="voyager-carousel__popup-image js-carousel-popup-image" >

                            </div>
                            <div class="voyager-carousel__popup-content">
                                <div class="voyager-carousel__popup-slider splide js-carousel-popup-slider">
                                    <div class="splide__track">
                                        <div class="splide__list">
                                            ${_self.popupSliderHTML()}
                                        </div>
                                    </div>
                                    <div class="splide__progress-bar--desktop voyager-carousel__popup-control-bar splide__control-bar voyager-control-bar">
                                    <div class="splide__arrows voyager-carousel__popup-splide-arrows">
                                        <button
                                            class="splide__arrow splide__arrow--prev">
                                            <i class="splide__arrows-icon splide__arrows-icon--prev voyager-icon-chevron-pointing-left-big voyager-icon"></i>
                                        </button>
                                        <button
                                            class="splide__arrow splide__arrow--next">
                                            <i class="splide__arrows-icon splide__arrows-icon--next voyager-icon-chevron-pointing-right-big voyager-icon"></i>
                                        </button>
                                    </div>
                                    <ul class="splide__pagination voyager-carousel__pagination splide__pagination--ltr voyager-carousel__popup-pagination" role="tablist" aria-label="Select a slide to show"></ul>
                                    </div>
                                </div>
                            </div>
                        </div>`;
        return outputHTML;      
    }   

    setPopupSliderData() {
        var _self = this,
            items = [];

        _self.splide.Components.Elements.slides.forEach(ele => {
            var popupImage = ele.querySelector('.voyager-card__image-wrapper').dataset.popupImage;
            if(!popupImage) {
                popupImage = ele.querySelector('.voyager-card__image').src
            }
            
            items.push({
                'image': popupImage, 
                'heading': _self.getInnerText(ele, '.voyager-card__heading'),
                'pre-heading': _self.getInnerText(ele, '.voyager-card__pre-heading'),
                'sub-heading': _self.getInnerText(ele, '.voyager-card__sub-heading'),
                'textarea': _self.getInnerText(ele, '.voyager-card__textarea'),
                'button1': _self.getInnerText(ele, '.voyager-buttons__button-wrapper1'),
                'button2': _self.getInnerText(ele, '.voyager-buttons__button-wrapper2')
            });
        });

        _self.popupSliderData = items;
    }

    popupSliderHTML() {
        var _self = this,
            outputHTML = '';

        _self.popupSliderData.forEach(item => {
            outputHTML += `
                        <div class="splide__slide">
                            <div class="voyager-carousel__popup-slide-wrapper">
                                <h3 class="voyager-carousel__popup-slide-heading">${item['heading']}</h3>
                                <p class="font-size--pre-heading voyager-carousel__popup-slide-pre-heading">${item['pre-heading']}</p>
                                <p class="font-size--sub-heading voyager-carousel__popup-slide-sub-heading">${item['sub-heading']}</p>
                                <div class="font-size--body-regular voyager-carousel__popup-slide-textarea">
                                    <p>${item['textarea']}</p>
                                </div>			
                                <div class="voyager-carousel__popup-buttons">
                                    <div class="voyager-carousel__popup-button-wrapper">
                                        ${item['button1']}
                                    </div>
                                    <div class="voyager-carousel__popup-button-wrapper">
                                        ${item['button2']}
                                    </div>
                                </div>		
                            </div>
                        </div>`;
        });

        return outputHTML;
    }

    getInnerText(item, className) {
        if(item.querySelector(className) !== null) {
            return item.querySelector(className).innerHTML
        } else {
            return '';
        }
    }

    splideInit(i) {
        var _self = this;
        var splide = new Splide( '.js-carousel-popup-slider', { 
            type: 'fade',
            // pagination  : true,         
            classes     : {
                // arrows: 'splide__arrows voyager-carousel-popup__arrows',
                // prev  : 'splide__arrow--prev voyager-carousel-popup__splide-arrow--prev',
                page  : 'splide__pagination-button',
            },
        });
        splide.mount();
        splide.go(i);

        splide.on( 'moved', function (newIndex, oldIndex) {
            _self.popupMain.querySelector('.js-carousel-popup-image').style.backgroundImage = 'url("'+ _self.popupSliderData[newIndex].image +'")'
        })
        _self.popupMain.querySelector('.js-carousel-popup-image').style.backgroundImage = 'url("'+ _self.popupSliderData[i].image +'")'
    }

    handleClosePopup() {
        var _self = this;

        if(typeof _self.popupMain !== undefined && _self.hasPopup) {
            _self.popupMain.remove();
            _self.hasPopup = false
        }
    }

    handleMouseOut() {
        var _self = this;
        _self.popupMain.querySelector('.js-carousel-popup-close').addEventListener('click', function() {
            _self.handleClosePopup();
        })
    }

    handleMobileSelectedItem() {
        var _self = this;
        _self.selectedItem.addEventListener('click', function() {
            this.parentElement.classList.toggle('filter-dropdown-active');
        })
    }

    filterInit(splide) {        
        if(this.blockMain) {
            this.handleFilterClick();
            this.splide = splide;
            this.splideElement = this.splide.Components.Slides.filter(`.splide__slide`);
            this.handleHoverItem();
        }
    }
}